import { FC } from 'react';
import { AdvertChunkDataByServiceType, AdvertCardList, AdvertType } from '@edikk-edikk/ui';
import { AdvertCardWrapper } from '#advert/components/advert-card/AdvertCardWrapper';
import catalogByServiceItemCss from '#srcCssModules/advert/catalog/catalog-by-service-item.module.scss';
import { LoadMore } from '#advertList/components/catalog-by-service/LoadMore';

type PropsType = {
  chunk: AdvertChunkDataByServiceType;
};

const CatalogByServiceItem: FC<PropsType> = ({
  chunk,
}) => (
  <div className={catalogByServiceItemCss.catalogByServiceItem}>
    <h3 className={catalogByServiceItemCss.catalogByServiceItem__title}>
      {chunk.title}
    </h3>
    <AdvertCardList
      adverts={chunk.adverts}
      renderCard={(advert: AdvertType, index: number) => (
        <AdvertCardWrapper
          key={advert.id}
          index={chunk.pagination.totalCount ? index : null}
          advert={advert}
        />
      )}
      total={chunk.pagination.totalCount}
    />
    <LoadMore
      pagination={chunk.pagination}
      serviceId={chunk.serviceId}
    />
  </div>
);

export { CatalogByServiceItem };
